module.exports = __webpack_public_path__ + "static/media/pdf.6c9d38ec.svg";